"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _theming = require("../../theming");

var _themeContants = require("../../constants/themeContants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var themeProps = {
  wrapper: {
    name: "code-renderer-wrapper",
    description: "code renderer wrapper style",
    type: _themeContants.themePropTypes.style
  }
};

var CodeWrapper = _styledComponents["default"].pre.withConfig({
  displayName: "CodeWrapper",
  componentId: "sc-1m254g7-0"
})(["min-width:300px;background-color:", ";color:", ";.token{color:", ";}.comment{color:", ";}.keyword{color:", ";}.operator{color:", ";}.function{color:", ";}.string{color:", ";}.punctuation{color:", ";}.number{color:", ";}.class-name{color:", ";}.tag{color:", ";}.attr-value{color:", ";}.attr-name{color:", ";}. ", ";"], (0, _theming.color)("codeBackground"), (0, _theming.color)("codeForeground"), (0, _theming.color)("codeForeground"), (0, _theming.color)("codeComment"), (0, _theming.color)("codeKeyword"), (0, _theming.color)("codeOperator"), (0, _theming.color)("codeFunction"), (0, _theming.color)("codeString"), (0, _theming.color)("codePunctuation"), (0, _theming.color)("codeNumber"), (0, _theming.color)("codeClass"), (0, _theming.color)("codeHTMLTag"), (0, _theming.color)("codeHTMLAttrValue"), (0, _theming.color)("codeHTMLAttrName"), (0, _theming.applyVariants)(themeProps.wrapper.name));

CodeWrapper.themeProps = themeProps;
var _default = CodeWrapper;
exports["default"] = _default;